import { Component, Inject, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgxFileDropEntry } from 'ngx-file-drop';
import { EsAttachmentService } from 'src/app/core/api-services/shared/es-attachment.service';
import { AttachmentConfigItem } from 'src/app/core/models/shared/Attachment';
import { EsAttachment } from 'src/app/core/models/shared/ServiceRequestTransactionEsData';
import { BaseFormComponent } from 'src/app/shared/base/BaseFormComponent';
import { WorkflowBaseService } from 'src/app/shared/base/WorkflowBaseService';

@Component({
  selector: 'app-attachment-form',
  templateUrl: './attachment-form.component.html',
})
export class AttachmentFormComponent extends BaseFormComponent {
  
  @Input() attachmentConfigs: AttachmentConfigItem[];
  @Input() attachments: EsAttachment[];
  @Input() isEditable: boolean;

  allowedExtensions =
    '.jpg, .png, .jpeg, .gif, .pdf, .bmp, .doc, .docx, .xls, .xlsx';
  maxAllowedFileSize = 3; //in MB

  constructor(
    translateService: TranslateService,
    @Inject('WorkflowService')
    public workflowService: WorkflowBaseService,
    private attachmentService: EsAttachmentService
  ) {
    super(translateService);
  }

  onFileDrop($event: NgxFileDropEntry[], config: AttachmentConfigItem) {
    for (const droppedFile of $event) {
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => this.uploadFile(file, config));
      }
    }
  }

  private validateFile(file: File, config: AttachmentConfigItem): boolean {
    let fileExt = file.name.split('.');

    config.invalidFileSize = file.size > this.maxAllowedFileSize * 1024 * 1024;
    config.invalidFileExtension =
      fileExt?.length > 0
        ? this.allowedExtensions.indexOf(fileExt[fileExt.length - 1]) == -1
        : false;
    return !config.invalidFileSize && !config.invalidFileExtension;
  }

  private async uploadFile(file: File, config: AttachmentConfigItem) {
    if (this.validateFile(file, config)) {
      let response = await this.attachmentService
        .uploadAttachment(file)
        .toPromise();
      if (response?.IsSuccess) {
        let attachment = this.hasAttachment(config.procedureAttachmentId);
        if (attachment) {
          this.attachments.splice(this.attachments.indexOf(attachment), 1);
        }
        if(!this.attachments)
          this.attachments = [];
        this.attachments.push({
          procedureAttachmentId: config.procedureAttachmentId,
          path: response.Data[0]?.FileId,
          attachmentFileName: response.Data[0]?.AttchfileNames,
        });
      }
    }
  }

  async downloadFile(procedureAttachmentId: number): Promise<void> {
    const fileId = this.hasAttachment(procedureAttachmentId).path;
    if (fileId) {
      const result = await this.attachmentService.download(fileId).toPromise();

      const blob = new Blob([this.dataURItoArray(result.Data.FileData)], {
        type: result.Data.FileMimeType,
      });

      const url = window.URL.createObjectURL(blob);
      window.open(url);
    }
  }

  private dataURItoArray(dataURI: string) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }

    return int8Array;
  }

  hasAttachment(procedureAttachmentId: number): EsAttachment {
    return this.attachments?.filter((a) => a.procedureAttachmentId == procedureAttachmentId)?.[0];
  }

  deleteAttachment(procedureAttachmentId: number) {
    const attachment = this.hasAttachment(procedureAttachmentId);
    this.attachments.splice(this.attachments.indexOf(attachment), 1);
  }
}
